import GiftForm from './GiftForm'

export default GiftForm
// eslint-disable-next-line import/export
export * from './GiftForm'
